import getConfig from 'next/config';

import React from 'react';
import { Link } from '../routes';

const {
  publicRuntimeConfig: {
    routePrefix: ROUTE_PREFIX,
  },
} = getConfig();

const prefixLink = uri => ROUTE_PREFIX + uri;

/* eslint-disable react/prop-types */

export default props => (
  <Link route={prefixLink(`/${props.locale}/trade/${props.market}`)} prefetch={true}>
    <a id={`exchange-recommendation-${props.market.replace('_', '-')}`}>
      {props.children}
    </a>
  </Link>
);
